<template>
  <section class="r-avatar-page">
    <ac-data-table
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="name"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Avatar"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Item
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">mdi-cloud-upload-outline</v-icon>
      </template>
      <template v-slot:item.icon="{item}">
        <v-image-view style="width: 50px;height: 50px" :path="row_image(item)"/>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-avatar-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {AvatarModel} from "@/modules/redactor/models/avatar/AvatarModel";

import VImageView from "@/views/com/ImageView";
import RAvatarDialog from "@/modules/redactor/views/avatar/r-avatar-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  components: {RDialogPreviewCollection, AcDataTable, RAvatarDialog, VImageView},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Name", value: "name"},
      {text: "Priority", value: "priority"},
      {text: "Icon", value: "icon", sortable: false},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(AvatarModel)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushAvatar(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushAvatar(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            if (this.row_duplicate(result)) {
              this.$alert("Duplicate found!");
            } else {
              RedactorUtils.pushAvatar(result).then(() => {
                this.$alert("Changes was published");
              });
            }
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeAvatar(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkAvatars(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushAvatar(result);
    },
    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
          .then(() => {
            RedactorUtils.convertAvatar(item.clone())
                .then(() => {
                  this.$alert("Changes was published", "Convert To Global", "success");
                })
                .catch((error) => {
                  this.$alert(error, "Convert To Global", "error");
                });
          });
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_image(item) {
      return 'assets/avatar/' + item.key + '.png'
    },
    row_duplicate(item) {
      return this.items.find(v => {
        return v.key === item.key && v.uid !== item.uid;
      });
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, AvatarModel, "avatar")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getAvatars();
  }
};
</script>